import { userPlanAtom } from 'app/atoms';
import { FREE_TRIAL_CREDIT_PLAN_CODE, useMyActivePlans } from 'app/network/plan';
import { getCreditUsedAt, getLoanDiscountDeadline } from 'app/utils/loan-discount';
import { useAtomValue } from 'jotai';

export function useLoanDiscount() {
  const plansQuery = useMyActivePlans();
  const cachedPlans = useAtomValue(userPlanAtom);
  const plans = plansQuery.data ?? cachedPlans ?? undefined;
  const creditPlan = plans?.find((plan) => plan.code.code === FREE_TRIAL_CREDIT_PLAN_CODE);
  const creditUsedAt = getCreditUsedAt(creditPlan?.expiresAt);
  const freeBorrowIsUsed = plans !== undefined && creditPlan ? creditUsedAt !== undefined : undefined;
  const discountDeadline = getLoanDiscountDeadline(creditPlan?.expiresAt);

  return { creditUsedAt, discountDeadline, freeBorrowIsUsed, isReady: plans !== undefined };
}
